import { useAuth } from '../../app/AuthProvider';
import { AuthCard } from './AuthCard';
import { Button, ErrorNote } from '../../ui/components';

export function NoAccessPage() {
  const { session, signOut, refresh, error } = useAuth();
  const email = session?.user.email ?? 'this account';
  return (
    <AuthCard title="No access yet">
      <div className="space-y-4 text-sm">
        <p>
          Your account <span className="font-medium">{email}</span> works, but nobody has invited it to the portal.
        </p>
        <p className="text-ink-muted">
          Ask an administrator to add that address on the People page. Then use Try again.
        </p>
        {error && <ErrorNote message={error} />}
        <div className="flex gap-2">
          <Button variant="primary" onClick={() => void refresh()}>Try again</Button>
          <Button onClick={() => void signOut()}>Sign out</Button>
        </div>
      </div>
    </AuthCard>
  );
}
